<template>
<div>
      <div class="container">
        <div class="compact-nav">
          <button class="button button-icon button-link menu-btn"><span class="ico material-icons">sort</span></button>
          <h1 class="title">Lessen</h1>
          <button class="btn btn-primary ml-auto" @click.prevent="showModal = true" :class="{'tutorial-focus': stepcount == 2}"><span class="ico material-icons">add_circle</span> LES</button>
        </div>

        <ul class="item-list lessons">
          <li v-for="setting in settings" >
            <a class="item lessons-item" :href="'/creator/'+setting.websiteid" :class="{'tutorial-focus': stepcount == 3}">
              <span class="item-image"></span>
              <span class="item-content">
                <strong class="item-title">
                    {{ setting.name }} 
                    <span class="item-icons">
                      <span class="ico material-icons">arrow_forward</span>
                    </span>
                </strong>
                <span class="item-desc text-muted">
                    {{ setting.tagline }} 
                </span>
              </span>
            </a>
          </li>
        </ul>

        <transition name="fade">
          <alert-bar v-if="msgtext" v-bind:class="msgclass">{{msgtext}}</alert-bar>
        </transition>

        <modal v-if="showModal" @close="showModal = false" title="Les toevoegen">
            <form @submit.prevent="createSetting()">
                <input-default label="Naam van les" description="Bijv: Wiskunde klas F" v-model="newsettingname" capitalizeNone="none"/>
                <button class="button" type="submit">Les toevoegen</button>
            </form>
        </modal>
      </div>
      <transition name="fade">
        <div class="tutorial-overlay" v-if="stepcount < 4">
          <div>
            <p>{{step.msg}}</p>
            <button class="btn btn-tutorial btn-lg" @click.prevent="nextStep(stepcount+1)">Ok</button>
          </div>
        </div>
      </transition>
  </div>
</template>

<script>
  import InputDefault from '../components/form/InputDefault.vue';
  import Modal from '../components/modal/Modal.vue';
  import AlertBar from '../components/form/Alert.vue';
  import Loader from '../components/ui/Loader.vue';
  import MainNav from '../components/navigation/MainNav.vue';
  import HomeBlock from '../components/content/HomeBlock.vue';
  import MagazineCards from '../components/content/MagazineCards.vue';

  import { userService } from '../services/user.service.js';
  import { authHeader } from '../services/auth-header.js';
  
  import axios from 'axios';

  export default {
    props:{
    },
    data: function (){
      return {
        tutorial: true,
        stepcount: '99',
        step:{msg: 'Hi, dit is een overzicht van de door jouw gemaakte lessen.'},
        showModal: false,
        msgtext: '',
        msgclass: 'error',
        username: '',
        password: '',
        submitted: false,
        loading: false,
        loggingin: false,
        newsettingname: '',
        newsettingdesc: '',
        returnUrl: '',
        error: '',
        settings: {},
        pages: {},
        userinfo: JSON.parse(localStorage.getItem('user'))
      }
    },
    created () {
    },
    components: {
      InputDefault,
      AlertBar,
      Loader,
      MainNav,
      HomeBlock,
      Modal,
      MagazineCards
    },
    methods: {
        nextStep(nextStepcount){
          this.stepcount = nextStepcount
          if(this.stepcount == 2){
            this.step.msg = 'Klik hierop om een nieuwe les aan te maken'
          }
          if(this.stepcount == 3){
            this.step.msg = 'Klik op "Mijn les" om door te gaan'
          }
          if(this.stepcount == 4){
            const requestOptions = {
              headers: authHeader()
            }

            const data = {
              user: JSON.parse(localStorage.getItem('user')).userId,
              step: 4,
            }

            axios.patch(process.env.VUE_APP_ROOT_API+'/users/step', data, requestOptions)
            .then(response => {
                console.log(response)
            })

            const placeholder = JSON.parse(localStorage.getItem('user'))
            placeholder['tourStep'] = 4;

            localStorage.setItem('user', JSON.stringify(placeholder));
            this.tutorial = false
          }
        },
        getSettings(){
            const requestOptions = {
              headers: authHeader()
            }

            axios.get(process.env.VUE_APP_ROOT_API+'/settings/user/'+this.userinfo.userId, requestOptions)
            .then(response => {
                console.log(response)
                this.settings = response.data.response
            })
        },
        removeUser(websiteid){
            const requestOptions = {
              headers: authHeader()
            }

            axios.delete(process.env.VUE_APP_ROOT_API+'/users/'+websiteid, requestOptions)
            .then(response => {
                this.msgtext = websiteid +' has been deleted'
                this.getUsers()
            })
        },
        createSetting(){

            const requestOptions = {
              headers: authHeader()
            }

            const data = {
              userId: JSON.parse(localStorage.getItem('user')).userId,
              lessonName: this.newsettingname
            }

            axios.post(process.env.VUE_APP_ROOT_API+'/settings/', data, requestOptions)
            .then(response => {
                this.newsettingname = ''
                this.showModal = false
                this.getSettings()
                console.log(response.data.response.websiteid)

                const userStorage = JSON.parse(localStorage.getItem('user'))
                userStorage['websiteid'].push(response.data.response.websiteid)

                localStorage.setItem('user', JSON.stringify(userStorage));
            })
        }
    },
    mounted(){
        this.getSettings()

        if(JSON.parse(localStorage.getItem('user'))){
          this.stepcount = JSON.parse(localStorage.getItem('user')).tourStep
        }
    }
  }
</script>
